import { render, staticRenderFns } from "./Typography1.vue?vue&type=template&id=5273e294&scoped=true"
import script from "./Typography1.vue?vue&type=script&lang=js"
export * from "./Typography1.vue?vue&type=script&lang=js"
import style0 from "./Typography1.vue?vue&type=style&index=0&id=5273e294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5273e294",
  null
  
)

export default component.exports